/* unplugin-vue-components disabled */import script from "./FileItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FileItem.vue?vue&type=script&setup=true&lang=js"

import "./FileItem.vue?vue&type=style&index=0&id=54a18f08&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a18f08"]])

export default __exports__